import { render, staticRenderFns } from "./FarmsEditFormFields.vue?vue&type=template&id=23ca7e24"
import script from "./FarmsEditFormFields.vue?vue&type=script&lang=js"
export * from "./FarmsEditFormFields.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports